import VehicleStatus from '@/dossier/constants/VehicleStatus';
import WorkStatus from '@/dossier/constants/WorkStatus';
import WorkshopTeam, { WorkshopTeamId } from '@/general/models/WorkshopTeam';
import Brand, { BrandId } from '@/shared/models/Brand';
import CommonFilters from '@/shared/models/CommonFilters';

export default class StatusBoardFilters {
  constructor(
    readonly common: CommonFilters,
    readonly teams: Array<WorkshopTeam>,
    readonly activeTeamIds: Array<WorkshopTeamId>,
    readonly brands: Array<Brand>,
    readonly activeBrandIds: Array<BrandId>,
    readonly workStatuses: Array<WorkStatus>,
    readonly vehicleStatuses: Array<VehicleStatus>,
  ) {}

  getActiveTeams(): Array<WorkshopTeam> {
    return this.teams.filter(team => this.activeTeamIds.includes(team.id));
  }

  getActiveBrands(): Array<Brand> {
    return this.brands.filter(brand => this.activeBrandIds.includes(brand.id));
  }
}
